var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "fade" } }, [
    _vm.visible
      ? _c(
          "div",
          {
            staticClass: "tds-overlay",
            on: {
              click: function ($event) {
                if ($event.target !== $event.currentTarget) {
                  return null
                }
                return _vm.onOverlayClick($event)
              },
            },
          },
          [
            _c("div", { staticClass: "tds-modal" }, [
              _c("div", { staticClass: "tds-modal__header" }, [
                _c("span", [_vm._v("3D Secure Authentication")]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "tds-modal__close",
                    on: { click: _vm.onClose },
                  },
                  [_vm._v("✕")]
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "tds-modal__body" }, [
                _vm.url
                  ? _c("iframe", {
                      ref: "tdsFrame",
                      staticClass: "tds-modal__frame",
                      attrs: { src: _vm.url, allow: "payment" },
                      on: { load: _vm.onFrameLoaded },
                    })
                  : _vm._e(),
              ]),
            ]),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }